module.exports = __webpack_public_path__ + "static/img-2-e5dd436960338c9f6abb6fce35f03acb.jpeg";